import { Box, Typography } from "@mui/material";
import { Dayjs } from "dayjs";
import { VIEWING_WINDOW_LABEL } from "./timelineLayout";

interface ViewingWindowTimeLabelProps {
  windowLeftPercent: number;
  viewingWindowStart: Dayjs;
  viewingWindowEnd: Dayjs;
  top?: number;
}

export const ViewingWindowTimeLabel = ({
  windowLeftPercent,
  viewingWindowStart,
  viewingWindowEnd,
  top = VIEWING_WINDOW_LABEL.top,
}: ViewingWindowTimeLabelProps) => {
  return (
    <Box
      sx={{
        position: "absolute",
        left: `${windowLeftPercent}%`,
        top,
        transform: "translateX(-50%)",
        bgcolor: "primary.main",
        color: "primary.contrastText",
        px: 1,
        py: 0.25,
        borderRadius: VIEWING_WINDOW_LABEL.borderRadius,
        pointerEvents: "none",
      }}
    >
      <Typography
        variant="caption"
        sx={{ fontSize: "0.7rem", fontWeight: "bold" }}
      >
        {viewingWindowStart.format("LT")} - {viewingWindowEnd.format("LT")}
      </Typography>
    </Box>
  );
};
